// extracted by mini-css-extract-plugin
export var linkText = "_ox-0";